/**
 * 掲載商品グループ選択画面の掲載商品グループクラス
 *
 * @export PublishGoodsGroup
 * @class PublishGoodsGroup
 */
export class PublishGoodsGroup {
  public check = false;
  constructor(public id: string, public name: string) {}
}
